import React, { createContext, useState } from 'react';

const ProviderSalesContext = createContext();

const ProviderSalesProvider = ({ children }) => {
  const [salesList, setSalesList] = useState([]);

  const updateProviderSale = (sale) => {
    setSalesList(salesList.map((s) => (s.id === sale.id ? sale : s)));
  };

  const updateSalesList = (newSalesList) => {
    setSalesList(newSalesList);
  };

  // const removeProviderProduct = (id) => {
  //   setSalesList(salesList.filter((p) => p.id !== id));
  // };

  return (
    <ProviderSalesContext.Provider value={{ salesList, updateSalesList, updateProviderSale}}>
      {children}
    </ProviderSalesContext.Provider>
  );
};

export { ProviderSalesContext, ProviderSalesProvider };

